export default __webpack_public_path__ + "static/media/tt-33.930d913e.svg";